import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberInfoStatusChangedModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_serial_number_info_status_changed",
                tableName: 'core_product_serial_number_info_status_changed'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            fied_detail: {
                refs: '  serial_number_id request_activation_id new_verify_status new_warranty_status note reason_type reason_code ',
                display: false
            }
        },)
    }

}